import { useEffect } from 'react';

const DynamicFavicon = () => {
  useEffect(() => {
    const updateFavicon = () => {
      try {
        const associate = process.env.REACT_APP_ASSOCIATE;
        
        if (associate) {
          const faviconElement = document.getElementById('dynamic-favicon');
          if (faviconElement) {
            faviconElement.href = `/images/${associate}/favicon.ico`;
          }
          
          const appleTouchIconElement = document.getElementById('dynamic-apple-touch-icon');
          if (appleTouchIconElement) {
            appleTouchIconElement.href = `/images/${associate}/logo.png`;
          }
        }
      } catch (error) {
        console.warn('Errore nell\'aggiornamento del favicon:', error);
        // Fallback al favicon di default
        const faviconElement = document.getElementById('dynamic-favicon');
        if (faviconElement) {
          faviconElement.href = '/images/artyou/favicon.ico';
        }
        
        const appleTouchIconElement = document.getElementById('dynamic-apple-touch-icon');
        if (appleTouchIconElement) {
          appleTouchIconElement.href = '/images/artyou/logo.png';
        }
      }
    };

    updateFavicon();
  }, []);

  return null; // Questo componente non renderizza nulla
};

export default DynamicFavicon; 